import esTranslations from './es.json';
import enTranslations from './en.json';

export type SupportedLanguage = 'es' | 'en';

export type HttpStatusCode = '400' | '401' | '402' | '403' | '404' | '408' | '409' | '500' | '503';

export interface Translations {
  errors: Record<HttpStatusCode, string>;
}

/**
 * Objeto de traducciones completo por idioma
 * Estructura extensible para agregar más traducciones en el futuro
 */
export const TRANSLATIONS: Record<SupportedLanguage, Translations> = {
  es: esTranslations,
  en: enTranslations
};

/**
 * Mantener compatibilidad con código existente
 * Acceso directo a mensajes de error HTTP
 */
export const ERROR_MESSAGES: Record<SupportedLanguage, Record<HttpStatusCode, string>> = {
  es: esTranslations.errors,
  en: enTranslations.errors
};

